<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
      <div class="d-flex align-items-center" style="gap: 10px">
        <div class="section-title">
          {{ $tc("distributor", 1) }} {{ $t("contract") }}
        </div>

        <div class="">
          <div class="dropdown-curve-container" style="width: 200px">
            <div class="d-flex align-items-center">
              <multiselect
                :multiple="true"
                placeholder="Select Cinema"
                :group-select="false"
                select-label="Select"
                label="cine_name"
                :options="cinemasName"
                deselect-label="Remove"
                track-by="cine_id"
                v-model="selectedCineIdObj"
              ></multiselect>
              <!-- @select="onSelectCinema($event, cinema.cine_id)"
                @remove="onRemoveCinema($event, cinema.cine_id)" -->
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              this.getDistributorContract(filterIsActive);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead class="text-center">
        <tr>
          <th class="text-left" style="width: 150px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>

          <th style="width: 355px" class="text-left">
            <img
              v-if="this.columnName != 'd_company_name'"
              @click="onSortValue('d_company_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('d_company_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('d_company_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("distributor", 1) }}
          </th>
          <th class="text-left" style="width: 310px">
            <img
              v-if="this.columnName != 'movie_title'"
              @click="onSortValue('movie_title', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('movie_title', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('movie_title', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("movie", 1) }}
          </th>
          <th class="text-left" style="width: 200px">
            <img
              v-if="this.columnName != 'cine_name'"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('cine_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('cine_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("cinema", 1) }}
          </th>
          <th class="text-left">{{ $tc("weekwiseContract", 1) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(
            distributorgetContract, distributorgetContractIndex
          ) in distributorgetContractList"
          :key="distributorgetContractIndex"
          class="light_grey_back"
        >
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  distributorgetContract.dc_is_active === 'Y'
                    ? 'active'
                    : distributorgetContract.dc_is_active === 'N' && 'inactive'
                "
              />

              <b-dropdown right variant="edit" class="ml-2">
                <b-dropdown-item
                  v-if="
                    !flag.isDistributor &&
                    $can('update', 'Distributor Contract')
                  "
                  @click="
                    goToRoute(
                      '/distributor/edit-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/distributor/view-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td style="width: 150px">
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="
                  distributorgetContract.dc_is_active === 'Y'
                    ? 'active'
                    : distributorgetContract.dc_is_active === 'N' && 'inactive'
                "
              />

              <i
                v-if="
                  !flag.isDistributor && $can('update', 'Distributor Contract')
                "
                class="edit-pen icon blue-icon cursor-pointer ml-2"
                @click.prevent.stop="
                  goToRoute(
                    '/distributor/edit-distributor-contract',
                    distributorgetContract
                  )
                "
                v-b-tooltip="'Edit'"
                tabindex="0"
              ></i>

              <i
                class="icon-eye blue-icon cursor-pointer ml-2"
                @click.prevent.stop="
                  goToRoute(
                    '/distributor/view-distributor-contract',
                    distributorgetContract
                  )
                "
                v-b-tooltip="'View'"
                tabindex="0"
              ></i>
            </div>
          </td>

          <td>
            {{ distributorgetContract.d_company_name }}
          </td>
          <td class="text-left">
            {{
              distributorgetContract.movie_name ||
              distributorgetContract.movie_title
            }}
          </td>
          <td class="text-left">
            {{ distributorgetContract.cine_name }}
          </td>
          <td class="text-left">
            {{ distributorgetContract.contract_weekwise_name }}
          </td>
        </tr>
        <tr v-if="distributorgetContractList.length == 0">
          <td colspan="5">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="distributorgetContractList.length > 0 && perPage !== 'all'"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(
          distributorgetContract, distributorgetContractIndex
        ) in distributorgetContractList"
        :key="distributorgetContractIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ distributorgetContract.d_company_name }}</h6>
            <h4>{{ distributorgetContract.cine_name }}</h4>
            <h4>{{ distributorgetContract.movie_title }}</h4>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="
                    !flag.isDistributor &&
                    $can('update', 'Distributor Contract')
                  "
                  @click="
                    goToRoute(
                      '/distributor/edit-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="
                    goToRoute(
                      '/distributor/view-distributor-contract',
                      distributorgetContract
                    )
                  "
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="text">{{ distributorgetContract.cine_name }}</div>
            </div>
            <div class="d-flex align-items-end">
              <div class="col-4">
                <StatusDot
                  :status="
                    distributorgetContract.dc_is_active === 'Y'
                      ? 'active'
                      : distributorgetContract.dc_is_active === 'N' &&
                        'inactive'
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="distributorgetContractList.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import MasterService from "@/services/MasterService";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      cinema_id: null,
      // Saif
      distributorgetContractList: [],

      distributorShareType: {
        dst_label: "",
        dst_fixed_value_to_theatre: "Y",
        dst_percentage_of: "Net Amount",
        dst_is_percentage: "Y",
        dst_duration: "Weekly",
        dst_is_active: "Y",
      },
      flag: {
        isDistributor: false,
      },
      // Saif
      gridView: false,
      listView: true,

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      searchValue: "",
      selectedCineId: "",
      selectedCineIdObj: "",
      cinemasName: [],
      filterIsActive: "Y",
    };
  },
  beforeMount() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    this.getCinemasList(this.cinema_id);
    this.getviewingnumber();
    this.getDistributorContract();
    if (
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO").role_name &&
      this.secureStore.get("USINFO").role_name === "Distributor"
    ) {
      this.flag.isDistributor = true;
    }
  },
  mounted() {},
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      if (this.perPage === "all") {
    return `Viewing All ${this.rows}`;
  }
      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    // onSelectCinema(event, cinema) {
    //   this.selectedCineId = event.cine_id;
    //   this.getDistributorContract();
    // },
    // onRemoveCinema(event, cinema) {
    //   this.selectedCineId = "";
    //   this.getDistributorContract();
    // },
    onSelectCinema(event) {
      this.selectedCineId = this.selectedCineIdObj.map((item) => item.cine_id);
      this.currentPage = 1;
      this.getDistributorContract();
    },
    onRemoveCinema(event) {
      this.selectedCineId = this.selectedCineIdObj.map((item) => item.cine_id);
      this.currentPage = 1;
      this.getDistributorContract();
    },

    getCinemasList: function (cine_id) {
      this.cinemasName = [];
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemasName = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = "all";
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getDistributorContract();
      } else {
        this.currentPage = event;
        this.getDistributorContract();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getDistributorContract();
    },
    // Saif
    getDistributorContract: function (filter_is_active = null) {
  //   if (filter_is_active) {
  //   this.filterIsActive = filter_is_active;
  // }
  if (filter_is_active !== null) {
    this.filterIsActive = filter_is_active;
    this.currentPage = 1; 
  }
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        // cinema_id: this.selectedCineId ? this.selectedCineId : "",
        cinema_id: Array.isArray(this.selectedCineId)
          ? this.selectedCineId.join(",")
          : "",
        searchValue: this.searchValue,
        filter_is_active: this.filterIsActive,
      };
      DistributorService.GetDistributorContract(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.distributorgetContractList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.distributorgetContractList = [];
              this.rows = 0;
              this.selectedvalue = 0;
            }
          } else {
            // Show Error Message
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error on getDistributorShareType :", error);
        });
    },
    goToRoute: function (path, { dc_id }) {
      this.$router.push({
        path: path,
        query: {
          id: dc_id,
        },
      });
    },
    // Saif

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
  watch: {
    selectedCineIdObj(newVal) {
      this.selectedCineId = newVal.map((item) => item.cine_id);
      this.currentPage = 1;
      this.getDistributorContract();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorContractComponents/distributorContract.vue